'use client';

import { c as _c } from "react/compiler-runtime";
import { type ComponentPropsWithoutRef, forwardRef } from 'react';
import { Context } from './context';
import { type CarouselOptions, useCarousel } from './useCarousel';
import { mergeProps } from './utils';
export interface CarouselProps extends Omit<CarouselOptions, 'children'>, ComponentPropsWithoutRef<'div'> {}
export const Carousel = forwardRef<HTMLDivElement, CarouselProps>(function Carousel(t0, ref) {
  const $ = _c(26);
  const {
    children,
    spaceBetweenItems: t1,
    scrollPadding,
    mouseDragging,
    autoplay,
    autoplayInterval,
    itemsPerPage: t2,
    loop,
    orientation: t3,
    scrollBy: t4,
    initialPages: t5,
    onActivePageIndexChange,
    ...props
  } = t0;
  const spaceBetweenItems = t1 === undefined ? "16px" : t1;
  const itemsPerPage = t2 === undefined ? 1 : t2;
  const orientation = t3 === undefined ? "horizontal" : t3;
  const scrollBy = t4 === undefined ? "page" : t4;
  let t6;
  if ($[0] !== t5) {
    t6 = t5 === undefined ? [] : t5;
    $[0] = t5;
    $[1] = t6;
  } else {
    t6 = $[1];
  }
  const initialPages = t6;
  let t7;
  if ($[2] !== autoplay || $[3] !== autoplayInterval || $[4] !== initialPages || $[5] !== itemsPerPage || $[6] !== loop || $[7] !== mouseDragging || $[8] !== onActivePageIndexChange || $[9] !== orientation || $[10] !== scrollBy || $[11] !== scrollPadding || $[12] !== spaceBetweenItems) {
    t7 = {
      spaceBetweenItems,
      scrollPadding,
      mouseDragging,
      autoplay,
      autoplayInterval,
      itemsPerPage,
      loop,
      orientation,
      scrollBy,
      initialPages,
      onActivePageIndexChange
    };
    $[2] = autoplay;
    $[3] = autoplayInterval;
    $[4] = initialPages;
    $[5] = itemsPerPage;
    $[6] = loop;
    $[7] = mouseDragging;
    $[8] = onActivePageIndexChange;
    $[9] = orientation;
    $[10] = scrollBy;
    $[11] = scrollPadding;
    $[12] = spaceBetweenItems;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  const carouselProps = t7;
  const [assignRef, carouselState] = useCarousel(carouselProps);
  const t8 = Context;
  let t9;
  if ($[14] !== assignRef || $[15] !== carouselProps || $[16] !== carouselState) {
    t9 = {
      assignRef,
      carouselState,
      carouselProps
    };
    $[14] = assignRef;
    $[15] = carouselProps;
    $[16] = carouselState;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  const t10 = mergeProps(carouselState.rootProps, props);
  let t11;
  if ($[18] !== children || $[19] !== ref || $[20] !== t10) {
    t11 = <div {...t10} ref={ref}>{children}</div>;
    $[18] = children;
    $[19] = ref;
    $[20] = t10;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== t11 || $[23] !== t8.Provider || $[24] !== t9) {
    t12 = <t8.Provider value={t9}>{t11}</t8.Provider>;
    $[22] = t11;
    $[23] = t8.Provider;
    $[24] = t9;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  return t12;
});